import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'radio',
    template: `
      <div [formGroup]="form">
      <div  style="margin-left: 10px;">
      <div *ngIf="!field.value">
        <div class="form-check" *ngFor="let opt of field.options">
          <input class="form-check-input" type="radio" [value]="opt.key" [checked]="field.value" [name]="field.name" [(ngModel)]="radioSelected" [formControl]="form" >
          <label class="form-check-label">
            {{opt.key}}
          </label>
        </div>
      </div>
     <span *ngIf="field.value"> <i class="fa fa-check"></i> &nbsp;{{field.value}}</span>
      </div>
      </div>  
    `
})
export class RadioComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;
    radioSelected: any;
    
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/dynamic-form-builder/atoms/radio.ts